import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RootContext from './context/RootContext';
import AppRoutes from './routes/AppRoutes';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './index.css';
import { ToastContainer } from 'react-toastify';
import { getTotals } from './redux/state/cart/CartSlice';
import { useDispatch, useSelector } from 'react-redux';
import CartToggleButton from './components/Button/CartToggleButton';
import CartDrawer from './components/Cart/CartDrawer';
import { trackPageView } from './services/utils/facebookPixel';

function App() {

  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState();

  const getFullYear = () => {
    setYear(new Date().getFullYear());
  };

  const [language, setLanguage] = useState(() => localStorage.getItem("language") || "en");
  const [isTranslating, setIsTranslating] = useState(false);

  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);

  const [isCartOpen, setIsCartOpen] = useState(false);
  const toggleCart = () => setIsCartOpen(prev => !prev);

  useEffect(() => {
    getFullYear();
    dispatch(getTotals());
    trackPageView();

    
  }, [cart.cartItems, dispatch]);

  return (
    <BrowserRouter>
      <ToastContainer />

      {/* Cart Button and Drawer will ALWAYS re-render when Redux updates */}
      <CartToggleButton toggleCart={toggleCart} />
      <CartDrawer isCartOpen={isCartOpen} toggleCart={toggleCart} width={300} />

      <RootContext.Provider value={{
        loading, setLoading, year,
        language, setLanguage,
        isTranslating, setIsTranslating
      }}>
        <AppRoutes />
      </RootContext.Provider>

    </BrowserRouter>
  );
}

export default App;
